import { render, staticRenderFns } from "./ClassSchedule.vue?vue&type=template&id=b15d18e6&scoped=true"
import script from "./ClassSchedule.vue?vue&type=script&lang=js"
export * from "./ClassSchedule.vue?vue&type=script&lang=js"
import style0 from "./ClassSchedule.vue?vue&type=style&index=0&id=b15d18e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15d18e6",
  null
  
)

export default component.exports